import React, { useContext, useEffect, useState } from "react";
import { ConfigurationContext } from "contexts";
import { useBrowserDetection, useSteps } from "hooks";
import { Typography } from "antd";
import { Progress } from "./Progress";
import Fade from "components/Fade";

const { Title } = Typography;
const stepName = "browserDetection";

const interval = 200; // Milliseconds for each update to progress meter.
//const allowedDuration = 4000; // Milliseconds allowed for entire operation.

/**
 *  The component.
 *
 */

const StepBrowserDetection = () => {
  const config = useContext(ConfigurationContext);
  let { steps, setCompleted, setError, nextStep } = useSteps();

  // State holding a timer.
  const [tick, setTick] = useState({
    interval: interval,
    limit: 90,
  });

  /**
   *  Done handler for browser detection.
   */
  const onDetectionDone = (evt) => {
    if (!evt.success) {
      // TODO: Figure out if any of these errors can happen. Also, should a dialog show?
      // Set the browser detection errors.
      setError({ browserDetectionTimeout: true, browserDetectionError: true });
    } else {
      //dropCookie(config);
    }
    finish();
  };

  // The browser detection hook.
  const runBrowserDetection = useBrowserDetection(onDetectionDone);

  /**
   *  Determine if the browser detection can or should run.
   */
  const canRun = () => {
    try {
      return (
        config.steps.browserDetection && !steps.state.browserDetection.completed
      );
    } catch (error) {
      console.log(`Step ${stepName} not found.`);
      return false;
    }
  };

  /**
   *  Finish and clean up for step. Move onto the next step.
   */
  const finish = () => {
    setTick({ limit: 100, interval: 10 });
    setTimeout(() => {
      setCompleted(stepName);
      nextStep();
    }, 2000);
  };

  // Run the browser detection in an effect.
  useEffect(() => {
    if (canRun()) {
      // Run the browser detection.
      runBrowserDetection();
    } else {
      // Nothing to do here so finish the step.
      finish();
    }
  }, []);

  // Check if the step should render.
  if (!canRun()) {
    return null;
  }

  // The render.
  return (
    <Fade show="show">
      <div className="mt-5 w-100">
        <Title style={{ textAlign: "center" }}>Gathering Data</Title>
        <Title style={{ textAlign: "center" }} level={4}>
          Gathering software and hardware data from various sources...
        </Title>
        <div className="w-100 text-center">
          <Progress interval={tick.interval} limit={tick.limit} />
        </div>
      </div>
    </Fade>
  );
};

export default StepBrowserDetection;
